export default __webpack_public_path__ + "static/accents-background-accent-tokens-light-52eca743e906341c104b6535656caf7d7f809b072daa3544b8c4a750ae4c87de.png";